import axios from 'axios';
import { ORDENES_SALIDA } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const listarOrdenes = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: filtros.id_proyecto ?? null,
        status: filtros.status ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/listar`, body, config);

        await dispatch({
            type: ORDENES_SALIDA.LISTAR,
            payload: res.data?.ordenes || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar órdenes de salida', 'danger'));
        return false;
    }
};

export const filtrarOrdenes = (texto = '') => dispatch => {
    dispatch({
        type: ORDENES_SALIDA.FILTRAR,
        payload: texto
    });
};

export const limpiarOrdenes = () => dispatch => {
    dispatch({ type: ORDENES_SALIDA.LIMPIAR });
};

export const obtenerOrden = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch({ type: ORDENES_SALIDA.DETALLE_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/detalles`, body, config);

        await dispatch({
            type: ORDENES_SALIDA.DETALLE,
            payload: res.data?.orden || null
        });

        await dispatch(changeLoader(false));
        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar la orden de salida', 'danger'));
        return null;
    }
};

export const limpiarDetalleOrden = () => dispatch => {
    dispatch({ type: ORDENES_SALIDA.LIMPIAR_DETALLE });
};

export const crearOrden = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: data.id_proyecto || '',
        id_cotizacion: data.id_cotizacion || null,
        fecha: data.fecha || null,
        total: data.total ?? 0,
        productos: Array.isArray(data.productos) ? data.productos : [],
        conceptos: Array.isArray(data.conceptos) ? data.conceptos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear la orden de salida', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de salida creada correctamente', 'success'));

        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear la orden de salida', 'danger'));
        return null;
    }
};

export const editarOrden = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        fecha: data.fecha || null,
        total: data.total ?? 0,
        productos: Array.isArray(data.productos) ? data.productos : [],
        conceptos: Array.isArray(data.conceptos) ? data.conceptos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar la orden de salida', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de salida editada correctamente', 'success'));

        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar la orden de salida', 'danger'));
        return null;
    }
};

export const cambiarStatusOrden = (id, status, productos = null, paquetes = null) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id,
        status,
        productos: Array.isArray(productos) ? productos : undefined,
        paquetes: Array.isArray(paquetes) ? paquetes : undefined
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/editar_status`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo actualizar el status de la orden', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Status de la orden actualizado correctamente', 'success'));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al actualizar el status de la orden', 'danger'));
        return false;
    }
};

export const eliminarOrden = (id, id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_salida/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar la orden de salida', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de salida eliminada correctamente', 'success'));

        await dispatch(listarOrdenes({ id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_SALIDA.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar la orden de salida', 'danger'));
        return false;
    }
};
